<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>
        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
             <div class="header">
                <v-icon large >business</v-icon>
                <div class="fullname" >{{ boardName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab-item :style="{ height: tabPageHeight }">
                    <v-text-field v-model="boardName" :label="$t('message.Name')"></v-text-field>
                    <v-select
                        v-model="selectedTypes"
                        :items="cardTypes"
                        item-text="name"
                        item-value="cardTypeId"
                        attach
                        chips
                        label="Card Types"
                        multiple ></v-select>

                    <draggable group="people" @start="drag=true" @end="drag=false" @update="onUpdate"  class="list-container" >
                        <div v-for="status in boardStatuses" v-bind:key="status.statusId" class="list-row">
                            <div class="list-columns">
                                 <v-icon style="cursor: grab;" >drag_indicator</v-icon>
                                 &nbsp;&nbsp;&nbsp;&nbsp;
                                <div >{{ status.name }}</div>
                            </div>
                            <div class="list-item-tools"> 
                                <v-btn flat icon small  @click="removeStatus(status)"><v-icon size="19px" color="#616161">delete</v-icon></v-btn>
                            </div>
                        </div>
                    </draggable>
                    
                    <v-tooltip right >
                        <v-btn color="lsecondary" flat icon  slot="activator" v-on:click="addStatus()" ><v-icon >add_circle</v-icon></v-btn>
                        <span>{{ $t('message.AddStatus') }}</span> 
                    </v-tooltip>

                    <v-select v-bind:class="{ hidden: statusDdlIsHidden }" 
                        v-model="selectedStatus"
                        :items="statuses"
                        item-text="name"
                        item-value="statusId"
                        label="Statuses"
                         ></v-select>
                    
                    <v-checkbox  v-model="currentUser" :label="$t('message.AssignToLoggedInUser')" ></v-checkbox>
                    <v-autocomplete  v-model="memberId" 
                            :items="members" 
                            :loading="isLoadingMembers" 
                            :search-input.sync="searchMember" 
                            item-text="name" 
                            item-value="memberId" 
                            :label="$t('message.Member')"
                            :no-data-text="$t('message.noMembersFound')" 
                            :disabled="disableMemberSelect">
                            </v-autocomplete>
                    <v-checkbox  v-model="sharedBoard" :label="$t('message.SharedBoard')" ></v-checkbox>
                    <v-checkbox  v-model="displayInMenu" :label="$t('message.DisplayInMenu')" ></v-checkbox>
                </v-tab-item>
            </v-tabs> 
        </div>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import HAL from "../../helpers/HAL.js";
import draggable from "vuedraggable";
import { mapGetters } from 'vuex';

export default {
    name: "EditBoard",
    computed: {
        ...mapGetters([
            'user'
        ]),
        computedPageHeight: function() {
            return this.pageHeight + 'px';
        },
        tabPageHeight: function() {
            var crtH = (this.pageHeight - 200);
            if(crtH < 200)
                crtH = 200;
            return crtH + 'px';
        },
        backLink: function () {
            return "/boards/" + this.boardId;
        }
    },
    components: {
      draggable
    },
    data() {
        return {
            pageHeight: 10,
            boardName: "",
            boardId: 0,
            cardTypes: [],
            statuses: [],
            searchMember: null,
            selectedTypes: [],
            boardStatuses: [],
            selectedStatus: null,
            members: [],
            currentUser: false,
            sharedBoard: false,
            displayInMenu: false,
            isLoadingMembers: false,
            memberId: null,
            disableMemberSelect: false,
            showmessage: false,
            statusDdlIsHidden: true,
            alertMessage: ''
        }
    },
    methods: {
        addStatus() {
            this.statusDdlIsHidden = false;
            this.selectedStatus = null;
        },
        removeStatus (item) {
            var ix = this.boardStatuses.indexOf(item);
            if(ix != -1) {
                this.boardStatuses.splice(ix, 1);
            }
        },
        onUpdate(event) {
            var item = this.boardStatuses.splice(event.oldDraggableIndex, 1);
            this.boardStatuses.splice(event.newDraggableIndex, 0, item[0]);
        },
        save() {
            var statusItems = [];
            for(let i in this.boardStatuses) {
                statusItems.push(this.boardStatuses[i].statusId);
            }
            var entity = {
                boardId: this.boardId,
                cardTypesId: this.selectedTypes,
                statusId: statusItems,
                memberId: this.memberId,
                loggedInUser: this.currentUser,
                sharedBoard: this.sharedBoard,
                displayInMenu: this.displayInMenu,
                name: this.boardName
            };
            this.showmessage = false;
            if (entity.boardId && entity.boardId > 0 ) {
                GenericRepository.update('/api/boards/' + this.boardId, entity).then(
                function(response) {
                    if (response.data && response.data.status == "Success") {
                        this.boardId = response.data.boardId;
                        window.vm.$router.push('/boards/' + this.boardId);
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                }.bind(this));
            }
            else {
                GenericRepository.insert('/api/boards', entity).then(
                function(response) {
                    if (response.data && response.data.status == "Success") {
                        this.boardId = response.data.boardId;
                        window.vm.$router.push('/boards/' + this.boardId);
                    }
                    else {
                        this.alertMessage = response.data.message;
                        this.showmessage = true;
                    }
                }.bind(this));
            }
        }
    },
    created() {
        this.pageHeight = window.innerHeight - 57 - 25 - 25;

        GenericRepository.getCollection('/api/cardtypes?offset=0&limit=25').then(function (response) {
            if(response.data && response.data.status == "Success") {
                let items = HAL.getEmbededResources(response.data, 'help:cardtype');
                this.cardTypes = items;
            }
        }.bind(this))
        .then(() => {
            GenericRepository.getCollection('/api/statuses?offset=0&limit=25')
            .then(function (res) {
                if(res.data && res.data.status == "Success") {
                    let items = HAL.getEmbededResources(res.data, 'help:status');
                    this.statuses = [ { statusId: null, name: '' }];
                    for(let i in items) {
                        this.statuses.push(items[i]);
                    }
                }
            }.bind(this))
            .finally(() => {
                if(this.$route.params.id) {
                    GenericRepository.getCollection('/api/boards/' + this.$route.params.id).then(function (response) {
                        if(response.data && response.data.status == "Success") {
                            this.boardId = response.data.boardId;
                            this.displayInMenu = response.data.displayInMenu;
                            this.currentUser = response.data.loggedInUser;
                            this.boardName = response.data.name;
                            this.selectedTypes = response.data.cardTypesId;
                            this.boardStatuses = [];
                            let sid = response.data.statusId;
                            for(let i in sid) {
                                let found = null;
                                for(let s in this.statuses) {
                                    if(this.statuses[s].statusId == sid[i]) {
                                        found = this.statuses[s];
                                        break;
                                    }
                                }
                                if(found)
                                    this.boardStatuses.push(found);
                            }
                            //this.ownerId = response.data.ownerId;
                            this.sharedBoard = response.data.sharedBoard;
                            if(response.data.member) {
                                this.members = [ {name: "", memberId: null}, { name: response.data.member.name, memberId: response.data.member.memberId } ];
                                this.memberId = response.data.member.memberId;
                            }
                        }
                    }.bind(this))
                }  
            })
        })
        
    },
    watch: {
        selectedStatus(value) {
            if(value > 0 ) {
                let found = false;
                for(let i in this.boardStatuses) {
                    if(this.statuses[i].statusId == value) {
                        found = true;
                    }
                }
                if(!found) 
                    for(let i in this.statuses) {
                        if(this.statuses[i].statusId == value) {
                            this.boardStatuses.push(this.statuses[i]);
                            break;
                        }
                    }
            }
            this.statusDdlIsHidden = true;
            this.selectedStatus = null;
        },
        currentUser(value) {
            if(value) {
                this.memberId = null;
                this.disableMemberSelect = true;
            }
            else {
                this.disableMemberSelect = false;
            }
        },
        searchMember(value) {
            if (!value || value.length < 3) return;

            if (this.isLoadingMembers) return;
            this.isLoadingMembers = true;

            GenericRepository.getCollection('/api/members?offset=0&limit=25&search=' +  value)
                .then(response => {
                    let items = HAL.getEmbededResources(response.data, "help:member");
                    this.members = [ {name: "", memberId: null} ];
                    for(let i in items) {
                        this.members.push({ memberId: items[i].memberId, name: items[i].firstName + ' ' + items[i].lastName});
                    }
                })
                .finally(() => (this.isLoadingMembers = false));
        }
     }
}
</script>


<style lang="stylus">
@import '../../assets/css/tool-bar.css';
@import '../../assets/css/entity-page.css';
@import '../../assets/css/inpagelist.css'
</style>